<template>
  <div class="evaluate">
    <!-- <div class="evaluate-header">评价</div> -->
    <div class="evaluate-content">
      <!-- 头像 -->
      <img
        class="evaluate-content-photo"
        :src="imgSrl"
        alt="头像"
      >
      <!-- 昵称 -->
      <p class="evaluate-content-name">{{name}}</p>
      <div class="evaluate-content-title">
        <div class="line"></div>
        <div class="text">请您对本次服务打分</div>
        <div class="line"></div>
      </div>
      <!-- 评分 -->
      <template v-for="(item, index) in scoreOptions">
        <evaluate-tag
          :label="item.label"
          :prop="item.prop"
          :tag-value="item.tagValue"
          :key="index"
          @change="tagChange"
        ></evaluate-tag>
      </template>
      <!-- 评论框 -->
      <el-input
        type="textarea"
        :maxlength="100"
        placeholder="您可以在此处留下您的意见或建议，谢谢！"
        v-model.trim="evaluation"
      >
      </el-input>
      <!-- 按钮 -->
      <el-button
        class="submit"
        :class="{disabledBtn: disabled}"
        v-loading="loading"
        :disabled="disabled"
        @click="evaluateSubmit"
      >匿名评价</el-button>
    </div>
  </div>
</template>

<script>
import { getUrlQuery } from '@/common/util'
import evaluateTag from '@/components/evaluate/evaluateTag.vue'
import evaluateService from '@/backend/services/evaluate/evaluate'
import '@/backend/styles/evaluate/base.scss'

export default {
  name: 'evaluate',
  data() {
    return {
      urlData: {},
      name: '',
      imgSrl: '',
      disabled: true,
      loading: false,
      scoreOptions: [
        {
          label: '态度',
          prop: 'attitudeScore',
          tagValue: {
            low: [], // 低评分标签
            high: [] // 高评分标签
          }
        },
        {
          label: '能力',
          prop: 'abilityScore',
          tagValue: {
            low: [], // 低评分标签
            high: [] // 高评分标签
          }
        }
      ],
      evaluation: '', // 评论内容
      abilityScore: '', // 能力值
      attitudeScore: '', // 态度值
      abilityTag: [], // 能力标签
      attitudeTag: [] // 态度标签
    }
  },
  mounted() {
    this.urlData = getUrlQuery()
    this.init()
    this.getInfo()
  },
  methods: {
    // 初始化评论标签数据
    async init() {
      try {
        let { urlData } = this
        let res = await evaluateService.getDictionary(urlData)
        if (res.status !== 200) {
          this.$router.push({ name: 'status', query: { status: 5 } })
          return false
        }
        let data = JSON.parse(res.data.templateContent)
        this.scoreOptions[0].tagValue.low = data.attitude.low
        this.scoreOptions[0].tagValue.high = data.attitude.high
        this.scoreOptions[1].tagValue.low = data.ability.low
        this.scoreOptions[1].tagValue.high = data.ability.high
      } catch (error) {
        // this.$router.push({ name: 'status', query: { status: 5 } })
      }
    },
    // 获取客户详情
    async getInfo() {
      let { evaluationId, signature, timestamp } = this.urlData
      let { data } = await evaluateService.getDetail({
        evaluationId,
        signature,
        timestamp
      })

      if (data.evaluationObjectEnName) {
        this.name = `${data.evaluationObjectName}（${data.evaluationObjectEnName}）`
      } else {
        this.name = data.evaluationObjectName
      }
      this.imgSrl = data.avatarUrl || require('@/assets/default.png')
    },
    // 改变标签
    tagChange(val) {
      if (val.abilityScore) {
        this.abilityScore = val.abilityScore
        this.abilityTag = val.tags
      }
      if (val.attitudeScore) {
        this.attitudeScore = val.attitudeScore
        this.attitudeTag = val.tags
      }
      this.btnValidation()
    },
    // 禁用判断
    btnValidation() {
      if (
        this.abilityScore &&
        this.attitudeScore &&
        this.abilityTag.length > 0 &&
        this.attitudeTag.length > 0
      ) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    // 提交评价
    async evaluateSubmit() {
      this.loading = true
      try {
        let {
          urlData,
          evaluation,
          abilityScore,
          attitudeScore,
          abilityTag,
          attitudeTag
        } = this

        // 数据汇总
        let params = Object.assign(
          {},
          {
            evaluationId: urlData.evaluationId,
            abilityLabel: abilityTag,
            abilityScore: abilityScore,
            attitudeLabel: attitudeTag,
            attitudeScore: attitudeScore,
            remark: evaluation.replace(
              /[^\u4E00-\u9FA5|\d|\x07-zA-Z|\r\n\s,.?!，。？！…—&$=()-+/*{}[\]]|\s/g,
              ''
            )
          }
        )
        await evaluateService.getUpdata(params, urlData)
        this.$router.push({
          name: 'status',
          query: { ...this.$route.query, status: 6 }
        })

        this.loading = false
      } catch (error) {
        this.loading = false
        this.$router.push({ name: 'status', query: { status: 5 } })
      }
    }
  },
  components: { evaluateTag }
  // beforeRouteEnter(to, from, next) {
  //   if (from.name == 'status' && from.query.appId) {
  //     wx.miniProgram.navigateBack()
  //   }
  //   next()
  // }
}
</script>
<style lang="scss">
.evaluate {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  &-header {
    width: 100%;
    height: 1.173rem;
    background: #3da1ff;
    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 0.48rem;
    font-weight: 600;
  }
  &-content {
    width: 100%;
    padding: 0.4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &-photo {
      width: 2.133rem;
      height: 2.133rem;
      border-radius: 50%;
    }
    &-name {
      color: #333;
      font-size: 0.373rem;
      height: 0.533rem;
      line-height: 0.533rem;
      margin: 0.267rem 0;
    }
    &-title {
      display: flex;
      align-items: center;
      justify-content: center;
      .line {
        width: 2.6rem;
        height: 0.027rem;
        background: #d8d8d8;
      }
      .text {
        font-size: 0.32rem;
        color: #999;
        margin: 0 0.4rem;
      }
    }
    .el-textarea__inner {
      padding: 0.267rem 0.347rem;
      width: 100%;
      height: 3.2rem;
      background: #f1f8ff;
      color: #666;
      font-size: 0.373rem;
      border-radius: 0.213rem;
    }
    .submit {
      width: 100%;
      height: 1.173rem;
      background: #3da1ff;
      color: #fff;
      font-size: 0.48rem;
      margin-top: 0.427rem;
    }
  }
  .disabledBtn {
    color: #fff !important;
    background: #aed8ff !important;
    border-color: #aed8ff !important;
  }
  .el-textarea__inner {
    border: none;
  }
}
</style>
